var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebstaurantstoreProductsScraper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#669a00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48883,
    stopColor: "#188900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006744"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64.88867,36.81464l-5.6098-3.23877-18.48682,10.67346,6.79388,3.9223c.36646.21155.81793.21155,1.18433,0l16.11841-9.30554c.78961-.45587.78961-1.59558,0-2.05145Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.58618,27.50885l-16.11823,9.30585c-.78955.45587-.78955,1.59558,0,2.05145l5.1319,2.96277,18.48712-10.67334-6.31641-3.64673c-.36646-.21155-.81793-.21155-1.18439,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.08203,71.49701v-18.68817c0-.41119-.21936-.7912-.5755-.99677l-6.8717-3.96753v9.87964l-4.19214-2.17682v-10.12317l-5.12061-2.95642c-.7674-.44305-1.72656.11072-1.72656.99677v18.68835c0,.41125.21936.7912.5755.99683l16.18451,9.34412c.76733.44305,1.7265-.11072,1.7265-.99683Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.53497,50.99768l-11.78607.00287-2.56567,12.3952,8.16522-9.78546c.11511-.09314.21405-.03925.33484-.00964.14966.03662,2.64996,1.21442,2.78931,1.30975.15363.1051.28033.17822.26154.39325l-2.36908,12.51294,7.89813-10.03882c.16077-2.67694.76105-6.23706-2.72821-6.78009Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.76154,68.66766c-.46454,5.5415,5.5271,3.56885,9.00299,3.90149l2.21661-11.72308-7.48505,9.27295c-.58887.26794-2.89178-1.43005-3.73456-1.45135Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M70.05957,72.57764c.78729,0,2.29547-1.72046,2.29547-2.46552v-4.16583l-5.78119,6.63135h3.48572Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.20416,51.49164c-.53687.01294-1.36731,1.49664-1.4436,1.95709v7.56653c.26483-.03754.27203-.72626.3125-.96289.33752-1.97211,1.30524-6.38458,1.22491-8.12933-.0069-.14996.07062-.41278-.09381-.4314Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebstaurantstoreProductsScraper);
export default __webpack_public_path__ + "static/media/webstaurantstore-products-scraper.01a4b4ee720cc58bb2e9dae5dcc504fd.svg";
export { ForwardRef as ReactComponent };